import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { logout } from "./redux/reducer";

const UserActivity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    dispatch(logout());
    navigate("/login");
  };

  const getSessionValueWithExpiration = (key) => {
    const storedData = sessionStorage.getItem(key);
    if (storedData) {
      const data = JSON.parse(storedData);

      if (data.expiration && new Date().getTime() < new Date(data.expiration).getTime()) {
        return data.value;
      }
      // Remove expired data
      sessionStorage.removeItem(key);
    }
    return null;
  };

  const restartAutoReset = () => {
    const authenticated = Cookies.get("authenticated");
    const expirationDate = new Date(); // Calcula la fecha de vencimiento
    expirationDate.setMinutes(
      expirationDate.getMinutes() +
        Number(process.env.REACT_APP_USER_ACTIVITY_MINUTES)
    );
    if (authenticated) {
      Cookies.set("onSession", "true", { expires: expirationDate });
      Cookies.set("authenticated", "true", { expires: expirationDate });
  const data = {
    value : "true",
    expiration: expirationDate,
  };
      sessionStorage.setItem("onSession", JSON.stringify(data));
      sessionStorage.setItem("authenticated", JSON.stringify(data));
    }
  };

  const onMouseMove = () => {
    restartAutoReset();
  };

  useEffect(() => {
    const authenticatedCookie = Cookies.get("authenticated");
    const onSessionCookie = Cookies.get("onSession");
    const authenticatedStorage = getSessionValueWithExpiration("authenticated");
    const onSessionStorage = getSessionValueWithExpiration("onSession");

    if (
      !(authenticatedCookie || authenticatedStorage) ||
      !(onSessionCookie || onSessionStorage)
    ) {
      logOut();
    }
    restartAutoReset();

    window.addEventListener("mousemove", onMouseMove);
    let interval = setInterval(() => {
      const authenticatedCookie = Cookies.get("authenticated");
      const onSessionCookie = Cookies.get("onSession");
      const authenticatedStorage = getSessionValueWithExpiration("authenticated");
      const onSessionStorage = getSessionValueWithExpiration("onSession");
      if (
        !(authenticatedCookie || authenticatedStorage) ||
        !(onSessionCookie || onSessionStorage)
      ) {
        logOut();
      }
    }, Number(process.env.REACT_APP_USER_ACTIVITY_MILISECONDS));

    return () => {
      if (interval) {
        clearInterval(interval);
        window.removeEventListener("mousemove", onMouseMove);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export default UserActivity;
